import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';

const embedJobDataSchema = Type.Object({
    clientCompanyId: Type.String(),
    sourceType: Type.Optional(Type.String()),
    sourceId: Type.Optional(Type.String()),
    assetId: Type.Optional(Type.String()),
});

const queueJobSchema = Type.Object({
    id: Type.String(),
    name: Type.String(),
    state: Type.String(),
    data: embedJobDataSchema,
    priority: Type.Number(),
    retryCount: Type.Number(),
    retryLimit: Type.Number(),
    createdOn: Type.String(),
    startedOn: Type.Union([Type.String(), Type.Null()]),
    completedOn: Type.Union([Type.String(), Type.Null()]),
    output: Type.Union([Type.Object({}), Type.Null()]),
    assetName: Type.Union([Type.String(), Type.Null()]),
});

const queueSummarySchema = Type.Object({
    all: Type.Number(),
    created: Type.Number(),
    active: Type.Number(),
    completed: Type.Number(),
    failed: Type.Number(),
    cancelled: Type.Number(),
});

export const aiQueuePaths = {
    '/api/ai/queue/jobs': {
        get: {
            operationId: 'aiQueueControllers.getJobs',
            parameters: [
                {
                    name: 'state',
                    in: 'query' as const,
                    schema: Type.Optional(Type.String()),
                },
                {
                    name: 'limit',
                    in: 'query' as const,
                    schema: Type.Optional(Type.String()),
                },
                {
                    name: 'offset',
                    in: 'query' as const,
                    schema: Type.Optional(Type.String()),
                },
            ],
            responses: {
                '200': {
                    description: 'List of embed queue jobs',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                items: Type.Array(queueJobSchema),
                                total: Type.Number(),
                            }),
                        },
                    },
                },
            },
        },
    },
    '/api/ai/queue/summary': {
        get: {
            operationId: 'aiQueueControllers.getSummary',
            responses: {
                '200': {
                    description: 'Queue summary counts',
                    content: {
                        'application/json': {
                            schema: queueSummarySchema,
                        },
                    },
                },
            },
        },
    },
    '/api/ai/queue/jobs/{jobId}': {
        parameters: [createPathGuidParameter('jobId')],
        delete: {
            operationId: 'aiQueueControllers.cancelJob',
            responses: {
                '200': {
                    description: 'Job cancelled',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                ok: Type.Boolean(),
                            }),
                        },
                    },
                },
            },
        },
    },
    '/api/ai/queue/jobs/{jobId}/resubmit': {
        parameters: [createPathGuidParameter('jobId')],
        post: {
            operationId: 'aiQueueControllers.resubmitJob',
            responses: {
                '200': {
                    description: 'Job resubmitted',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                ok: Type.Boolean(),
                                newJobId: Type.Union([Type.String(), Type.Null()]),
                            }),
                        },
                    },
                },
            },
        },
    },
} as const;
